import React from 'react';
import { ListingCard, NamedLink } from '../../../components';
import Slider from 'react-slick';
import classNames from 'classnames';
import { renderDefaultListingSizes } from '../../../util/enums';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

function SectionRecentlyAdded(props) {
  const { listings, intl, sliderSettings } = props;

  const title = intl.formatMessage({ id: 'FeaturedListings.title' });
  const viewAllSpaces = intl.formatMessage({ id: 'FeaturedListings.viewAll' });

  return (
    <div className={classNames(css.popularSessions, css.sectionPadding)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <h2 className={css.sectionTitle}>Recently Added</h2>
          <div className={css.seeAllSec}>
            <NamedLink name="SearchPage" className={css.findLink}>
              {viewAllSpaces}
            </NamedLink>
          </div>
        </div>
        <div className={css.featuredListingsContent}>
          <div className={css.templatesSlider}>
            <Slider {...sliderSettings}>
              {listings.map(l => (
                <ListingCard
                  className={css.listingCard}
                  key={l.id.uuid}
                  listing={l}
                  renderSizes={renderDefaultListingSizes}
                  setActiveListing={() => {}}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}

// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 4, // Display 4 items on desktop
  slidesToScroll: 1, // Scroll 1 item at a time
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1280, // Adjust settings for smaller viewports
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 768, // Adjust settings for smaller viewports
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 580, // Adjust settings for smaller viewports
      settings: {
        slidesToShow: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 550, // Adjust settings for smaller viewports
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        centerMode: true,
      },
    },
  ],
};

// Assign default props
SectionRecentlyAdded.defaultProps = {
  sliderSettings,
};

export default SectionRecentlyAdded;
